module.exports = __webpack_public_path__ + "static/media/silvana.ef8a6d0f.jpg";